import { ReactNode } from 'react'
import { TooltipProps } from '@material-ui/core'
import AppTooltip from './AppTooltip'
import InfoIcon from './Icons/InfoIcon'

interface InfoTooltipProps {
  text: ReactNode
  ariaLabel?: string
  placement?: TooltipProps['placement']
}

const InfoTooltip = ({ text, ariaLabel = 'More information', placement = 'top' }: InfoTooltipProps): JSX.Element => (
  <AppTooltip
    title={<span style={{ display: 'block', fontSize: '14px', lineHeight: 1.45 }}>{text}</span>}
    placement={placement}
    arrow
  >
    <button
      type="button"
      aria-label={ariaLabel}
      className="inline-flex items-center justify-center rounded-full p-0.5 text-stone-gray hover:text-dark-blue focus:outline-none focus-visible:ring-2 focus-visible:ring-dark-blue"
    >
      <InfoIcon />
    </button>
  </AppTooltip>
)

export default InfoTooltip
